/* Kick Frame — "Complete the wall": het blok "Goes well with" / "Past mooi bij" onder een product toont
   posters die er echt bij passen (zelfde club, stadion, land of legende) i.p.v. steeds
   dezelfde vier, plus de echte acties (2 A3 voor €44,99 en 2e A4 voor €14,99). Lukt het ophalen niet,
   dan blijft het oorspronkelijke blok gewoon staan. Op /nl vertaalt kf-i18n.js de teksten. */
(function () {
  var m = location.pathname.match(/\/products\/([^/?#]+)/);
  if (!m) return;
  var self = decodeURIComponent(m[1]);
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var NL = /^\/nl(\/|$)/.test(location.pathname);
  var section = [].slice.call(document.querySelectorAll('section')).filter(function (s) {
    var h = s.querySelector('h2');
    return h && /Goes well with|Past mooi bij/i.test(h.textContent) && s.querySelector('.product-grid');
  })[0];
  if (!section) return;

  var groups = [
    ['anfield-liverpool', 'virgil-van-dijk'],
    ['camp-nou-barcelona', 'lamine-yamal', 'pedri-gavi', 'raphinha', 'frenkie-de-jong', 'ferran-torres', 'ronaldinho', 'luis-suarez'],
    ['mbappe-real-madrid', 'vinicius-jr', 'bellingham', 'ronaldo-real-madrid', 'sergio-ramos', 'cr7'],
    ['old-trafford-manchester-united', 'ronaldo-manchester-united', 'cr7'],
    ['etihad-stadium-manchester-city', 'erling-haaland'],
    ['parc-des-princes-psg', 'mbappe-psg', 'neymar-jr'],
    ['de-kuip-feyenoord', 'virgil-van-dijk', 'frenkie-de-jong', 'cruyff', 'gullit'],
    ['ronaldinho', 'cruyff', 'gullit', 'messi', 'cr7', 'neymar', 'luis-suarez'],
    ['harry-kane', 'jamal-musiala', 'michael-olise'],
    ['bukayo-saka', 'cole-palmer', 'son-heung-min', 'harry-kane'],
    ['juventus-stadium', 'stadio-maradona-napoli']
  ];
  var stadiums = ['anfield-liverpool', 'camp-nou-barcelona', 'old-trafford-manchester-united', 'etihad-stadium-manchester-city',
    'parc-des-princes-psg', 'de-kuip-feyenoord', 'juventus-stadium', 'stadio-maradona-napoli'];
  var picks = ['vinicius-jr', 'pedri-gavi', 'mbappe-real-madrid', 'lamine-yamal', 'anfield-liverpool', 'jamal-musiala', 'erling-haaland'];

  var list = [];
  function add(h) { if (h !== self && list.indexOf(h) === -1) list.push(h); }
  groups.forEach(function (g) { if (g.indexOf(self) !== -1) g.forEach(add); });
  if (stadiums.indexOf(self) !== -1) stadiums.forEach(add);
  picks.forEach(add);
  list = list.slice(0, 4);

  function kfName(t) { return String(t || '').replace(/ (Football Poster|Stadium Poster|Voetbalposter|Stadionposter)$/, ''); }
  function money(cents) { return '€' + (cents / 100).toFixed(2); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function img(src, w) {
    if (!src) return '';
    src = src.indexOf('//') === 0 ? 'https:' + src : src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  /* oude prijs alleen tonen als de goedkoopste variant (de "vanaf"-prijs) zelf een oude prijs heeft */
  function minCompare(p) {
    var v = (p.variants || []).filter(function (x) { return x.price === p.price_min && x.compare_at_price > x.price; })[0];
    return v ? v.compare_at_price : 0;
  }

  Promise.all(list.map(function (h) {
    return fetch(root + 'products/' + h + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); });
  })).then(function (products) {
    var grid = section.querySelector('.product-grid');
    grid.innerHTML = products.map(function (p) {
      var cmp = minCompare(p);
      /* Sale-label alleen als de getoonde "vanaf"-prijs zelf afgeprijsd is (zelfde regel als de productkaart) */
      var sale = cmp > 0;
      var src = p.featured_image;
      return '<a class="product-card" href="' + root + 'products/' + esc(p.handle) + '">'
        + '<div class="product-media">' + (sale ? '<span class="badge badge--nieuw">Sale</span>' : '')
        + '<img src="' + esc(img(src, 800)) + '" srcset="' + esc(img(src, 400)) + ' 400w, ' + esc(img(src, 600)) + ' 600w, ' + esc(img(src, 800)) + ' 800w"'
        + ' sizes="(max-width: 48rem) 50vw, 25vw" alt="' + esc(kfName(p.title)) + ' poster" width="600" height="800" loading="lazy"></div>'
        + '<div class="product-info"><div><h3>' + esc(kfName(p.title)) + '</h3></div>'
        + '<span class="price">from ' + money(p.price_min)
        + (cmp ? ' <s style="opacity:.55;font-weight:400">' + money(cmp) + '</s>' : '') + '</span></div></a>';
    }).join('');

    var eyebrow = section.querySelector('.eyebrow');
    if (eyebrow) eyebrow.textContent = 'Complete the wall';
    var head = section.querySelector('.section-head');
    if (head && !section.querySelector('.kf-deal')) {
      var deal = document.createElement('p');
      deal.className = 'kf-deal';
      deal.innerHTML = NL
        ? '<strong>2 A3-posters voor €44,99</strong> · <strong>2e A4-poster voor €14,99</strong> · combineer elk ontwerp, de korting gaat automatisch'
        : '<strong>2 A3 posters for €44.99</strong> · <strong>2nd A4 poster for €14.99</strong> · mix any designs, the discount is applied in your cart';
      deal.style.cssText = 'margin:-.5rem 0 1.5rem;font-size:.95rem;color:var(--ink);opacity:.85';
      head.parentNode.insertBefore(deal, head.nextSibling);
    }
  }).catch(function () { /* oorspronkelijke blok blijft staan */ });
})();
